import React from "react";
import {
  AppstoreAddOutlined,
  BarChartOutlined,
  CalendarOutlined,
  IdcardOutlined,
  MessageOutlined,
  OrderedListOutlined,
  ProjectOutlined,
  SettingOutlined,
  TagOutlined,
  TeamOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

/**
 * The things you can do from anywhere, as opposed to the things you can find.
 *
 * Each one is a place the panel already has — the palette does not invent
 * actions, it removes the clicks between here and there. `permission` hides a
 * command from anyone who would land on a page they cannot use; `keywords`
 * carries the words someone would actually type, including the ones that are
 * not in the label. `module` hides a command belonging to an optional module
 * the workspace has turned off — the same rule the sidebar and the routes use.
 */
export const COMMANDS = [
  {
    key: "new-project",
    label: "پروژه‌ی جدید",
    icon: <ProjectOutlined />,
    to: "/projects?action=new",
    permission: "manage_projects",
    keywords: "ساخت پروژه ایجاد new project",
  },
  {
    key: "new-user",
    label: "دعوت کاربر جدید",
    icon: <UserAddOutlined />,
    to: "/users?action=new",
    permission: "manage_users",
    keywords: "افزودن عضو دعوت کاربر invite user",
  },
  {
    key: "new-template",
    label: "قالب پروژه‌ی جدید",
    icon: <AppstoreAddOutlined />,
    to: "/projectTemplates/create",
    permission: "manage_templates",
    keywords: "قالب تمپلیت template",
  },
  {
    key: "my-tasks",
    label: "تسک‌های من",
    icon: <OrderedListOutlined />,
    to: "/my-tasks",
    keywords: "کارهای من تسک task",
  },
  {
    key: "all-tasks",
    label: "همه تسک‌ها",
    icon: <OrderedListOutlined />,
    to: "/all-tasks",
    permission: "manage_tasks",
    keywords: "تسک های سازمان همه tasks",
  },
  {
    key: "calendar",
    label: "تقویم",
    icon: <CalendarOutlined />,
    to: "/calendar",
    keywords: "تقویم جلسه رویداد calendar",
  },
  {
    key: "chat",
    label: "پیام‌ها",
    icon: <MessageOutlined />,
    to: "/chat",
    module: "chat",
    keywords: "چت گفتگو پیام chat",
  },
  {
    key: "customers",
    label: "مشتریان",
    icon: <IdcardOutlined />,
    to: "/customers",
    module: "customers",
    permission: "manage_customers",
    keywords: "مشتری طرف حساب crm customer client",
  },
  {
    key: "new-customer",
    label: "مشتری جدید",
    icon: <IdcardOutlined />,
    to: "/customers/create",
    module: "customers",
    permission: "manage_customers",
    keywords: "افزودن مشتری ثبت مشتری new customer",
  },
  {
    key: "organization-overview-report",
    label: "وضعیت کلی سازمان",
    icon: <BarChartOutlined />,
    to: "/reports/organization-overview-report",
    permission: "manage_org",
    keywords: "وضعیت سلامت سازمان گزارش کلی overview health report",
  },
  {
    key: "users-report",
    label: "گزارش عملکرد کاربران",
    icon: <BarChartOutlined />,
    to: "/reports/users-performance-report",
    permission: "manage_org",
    keywords: "گزارش عملکرد کاربران report",
  },
  {
    key: "projects-report",
    label: "گزارش عملکرد پروژه‌ها",
    icon: <BarChartOutlined />,
    to: "/reports/projects-performance-report",
    permission: "manage_org",
    keywords: "گزارش پروژه عقب افتاده report",
  },
  {
    key: "teams",
    label: "تیم‌ها",
    icon: <TeamOutlined />,
    to: "/teams",
    permission: "manage_users",
    keywords: "تیم گروه team",
  },
  {
    key: "tags",
    label: "برچسب‌ها",
    icon: <TagOutlined />,
    to: "/tags",
    keywords: "برچسب تگ tag label",
  },
  {
    key: "organization",
    label: "تنظیمات سازمان",
    icon: <SettingOutlined />,
    to: "/organization",
    permission: "manage_org",
    keywords: "سازمان تنظیمات اطلاعات organization settings",
  },
];

export default COMMANDS;
